import gql from "graphql-tag";

export const RemoveRequest = gql`
  mutation RemoveRequest($requestId: String!) {
    deleteRequest(id: $requestId)
  }
`;
